import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from '../ui/Section';
import { ButtonLink } from '../ui/Button';
import { SELL_IMAGE } from '../../data/vehicles';
const pasos = ['Analizamos tu unidad y definimos el precio de publicación', 'Tomamos fotos profesionales y armamos la ficha completa', 'Publicamos y promocionamos en nuestros canales', 'Filtramos interesados reales y coordinamos las consultas', 'Negociamos con asesoramiento y te acompañamos hasta el cierre'];
const beneficios = ['Mayor exposición', 'Atención profesional', 'Menos pérdida de tiempo', 'Mejor presentación del vehículo', 'Acompañamiento comercial', 'Operación más segura'];
export function VenderSection() {
  return <Section id="vender" data-id="element-540" data-mp="2p0w4db7tmkt7">
      <div className="grid gap-10 lg:grid-cols-[1fr_1.05fr] lg:gap-16" data-id="element-541" data-mp="2p278jc56huku">
        <div data-id="element-542" data-mp="iafzvh8n6ywk">
          <h2 className="text-3xl font-extrabold leading-[1.1] tracking-tight text-white md:text-[42px]" data-id="element-543" data-mp="i7tof6imrz92">
            Vendé tu auto con VCARS
          </h2>
          <p className="mt-4 text-lg font-semibold text-white/90" data-id="element-544" data-mp="4k2bizba8zix">
            Nosotros gestionamos la venta de tu auto por vos.
          </p>
          <p className="mt-3 max-w-xl text-base leading-relaxed text-mist" data-id="element-545" data-mp="hfpxg57gau6">
            Publicamos, promocionamos, filtramos interesados, coordinamos consultas y te
            acompañamos durante la operación.
          </p>

          <div className="mt-8 overflow-hidden rounded-2xl border border-line" data-id="element-546" data-mp="3hrdsm13q69kf">
            <img src={SELL_IMAGE} alt="Sesión de fotos profesional de un vehículo en el estudio de VCARS" loading="lazy" className="h-56 w-full object-cover md:h-72" data-id="element-547" data-mp="3htgrzbqrpf1t" />
          </div>

          <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3" data-id="element-548" data-mp="3mpp5ylt8b27e">
            {beneficios.map(b => <li key={b} className="flex items-start gap-2 text-sm text-white/90" data-id="element-549" data-mp="16yaxg9jm38s6">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-neon" aria-hidden="true" data-id="element-550" data-mp="11zg62j7kwbwg" />
                {b}
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-551" data-mp="1e2slz4rov8ut">
            <ButtonLink to="/vender-mi-auto" size="lg" data-id="element-552" data-mp="1e210imrt2ri9">
              Quiero vender mi auto
            </ButtonLink>
          </div>
        </div>

        <ol className="relative space-y-6 border-l border-line pl-8" data-id="element-553" data-mp="1izsq3a4za1ja">
          {pasos.map((p, i) => <li key={p} className="relative" data-id="element-554" data-mp="1nym73cjh4ao7" data-mpi={i}>
              <span className="absolute -left-[45px] grid h-8 w-8 place-items-center rounded-full border border-neon/40 bg-ink text-[13px] font-bold text-neon" data-id="element-555" data-mp="qdzo32riaqxk">
                {i + 1}
              </span>
              <p className="text-[15px] leading-relaxed text-white/90" data-id="element-556" data-mp="10acnmh9qfz08">{p}</p>
            </li>)}
          <li className="rounded-2xl border border-line bg-surface2/50 p-5" data-id="element-557" data-mp="152w4bn3pva99">
            <p className="text-sm leading-relaxed text-mist" data-id="element-558" data-mp="7ni8lzvopru5">
              “Publicamos y gestionamos la venta de tu auto por vos.” Vos recibís
              únicamente consultas filtradas y avanzás con respaldo comercial en cada
              paso.
            </p>
          </li>
        </ol>
      </div>
    </Section>;
}